import React from "react";
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

const btn = "inline-flex h-9 items-center whitespace-nowrap rounded-full px-4 text-[13.5px] font-medium transition-colors disabled:opacity-50";

/** Leaving a valve with an unsaved configuration draft is a decision, not a surprise: save, discard, or stay. */
export function UnsavedDialog({ open, tag, canSave, busy, onSave, onDiscard, onCancel }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <AlertDialogContent className="max-w-[440px] rounded-[18px]" data-testid="ventil-unsaved">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-[17px]">Ulagret konfigurasjon på {tag}</AlertDialogTitle>
          <AlertDialogDescription className="text-[13.5px]">Du har endret aktuator eller tilvalg uten å lagre. Hva skal skje med utkastet før du går videre?</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-wrap gap-2 sm:justify-start">
          <button type="button" disabled={!canSave || busy} onClick={onSave} className={`${btn} bg-[hsl(var(--brand))] text-white hover:bg-[hsl(var(--brand-strong))]`} title={canSave ? "Lagre valget og gå videre" : "Utkastet kan ikke lagres ennå – begrunnelse eller forhåndsvisning mangler"} data-testid="ventil-unsaved-save">Lagre og gå videre</button>
          <button type="button" disabled={busy} onClick={onDiscard} className={`${btn} border border-black/[0.1] hover:bg-black/[0.04]`} data-testid="ventil-unsaved-discard">Forkast utkastet</button>
          <button type="button" onClick={onCancel} className={`${btn} text-foreground/70 hover:bg-black/[0.05] sm:ml-auto`} data-testid="ventil-unsaved-cancel">Fortsett redigering</button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
